import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/axiosConfig"; // Configures axios global timeout — must run before any API call
import App from "@/App";
import { installTranslateSafeDomPatches } from "@/utils/translateSafe";

// Patch Node.prototype.removeChild / insertBefore BEFORE React mounts so the
// app survives when users enable Google Translate or similar browser
// extensions that swap DOM nodes mid-render.
installTranslateSafeDomPatches();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
